<template>
  <div class="header">
    <nav role="navigation">
      <div id="menuToggle">
          <input 
            type="checkbox"
            v-model="menuShow"
            role="button"/>
          <img class="btn_menu" :class="{ 'btn_close': menuShow }" :src="getOpenCloseIcon"/>
      </div>
      <router-link to="/" class="logo">
        <img class="header_logo" :src="header_logo" alt="Uptown">
      </router-link>
      <transition name="fade">
        <div id="menu" v-if="menuShow"> 
          <ul>
            <li v-for="item in menuItems" :key="item.label">
              <router-link v-if="!item.link.includes('#')" :to="item.link" @click.native="linkClick" class="title">
                {{ item.label }}
              </router-link>
              <a v-if="item.link.includes('#')" href="#" @click.prevent="scrollToElement(item.link)" class="title">
                {{ item.label }}
              </a>
            </li>
          </ul>
          <hr />
          <p><a class="contact" :href="'tel:'+ telephone">{{telephone}}</a></p>
          <p><a class="contact" :href="'mailto:' + email ">{{email}}</a></p>
          <FooterSocialMedia class="social-media"></FooterSocialMedia>
        </div>
      </transition>
    </nav>
  </div>
</template>

<script>

import FooterSocialMedia from "../Footer/FooterSocialMedia"

export default {
    name: 'Menu',
    components: {
      FooterSocialMedia
    },
    data(){
        return{ 
          window: {
            width: 0,
            height: 0
          },
          menuItems: [
              {
                  label: "Home",
                  link: "/"
              },
              {
                  label: "Work",
                  link: "/work"
              },
              {
                  label: "About",
                  link: "/about"
              },
              {
                  label: "Inquire",
                  link: "#footer"
              },
          ],
          telephone: "705.712.3227‬",
          email: "team@uptowncreative.io",
          menuShow: false,
          shortMenu: false,
          header_logo: '/images/header-logo.svg'
      }
    },
    methods: {
      linkClick(){
        this.menuShow = false;
      },
      handleScroll(){
        if (this.window.width < 576){
          this.shortMenu = true;
        } else {
          if (window.scrollY > 160){
            this.shortMenu = true;
          }else if(window.scrollY < 20){
            this.shortMenu = false;
          }
        }
      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      scrollToElement(id) {
          const el = document.getElementById(id.slice(1));
          if (el) {
              el.scrollIntoView();
          }
          this.menuShow = false;
      },
    },
    computed:{
      getOpenCloseIcon(){
        if(this.menuShow){
          return '/images/hamburger-close.png'
        }
        else{
          return '/images/hamburger.svg';
        }
      }
    },
    created: function(){
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
      if (this.window.width < 576){
        this.shortMenu = true;
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize)
    },
    watch:{
      $route (){
          this.menuShow = false;
      }
    } 
    
}
</script>

<style lang="scss" scoped>
.header{
  top: 0;
  position: sticky;
  z-index: 20;
}
nav {
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  background:#fff;
  border-bottom: 1px solid #d9d9d9;
  height: 56px;
  .logo{
    text-decoration: none;
    letter-spacing: 3px;
    margin: 16px 0;
  }
  .header_logo{
    width: auto;
    height: 21px;
    align-self: center;
    display: block;
  }
  #menuToggle {
    position: absolute;
    top: 21px;
    right: 70px;
    z-index: 20;
    user-select: none;
    color: #000;
    span{
      position:relative;
      top: -2px;
      margin-right: 10px;
      letter-spacing: 4px;
      font-size: 12px;
    }
    input {
      display: block;
      width: 60px;
      height: 30px;
      right: -15px;
      top: -10px;
      position: absolute;
      cursor: pointer;
      opacity: 0; /* hide this */
      z-index: 2; /* and place it over the hamburger */
      -webkit-touch-callout: none;
    }
  }
  
  hr{
    margin-top: 30px;
    width: 40%;
    margin-bottom: 1rem
  }
  p{
    font-weight: bold;
    padding: 1rem 0;
    margin: 0;
  }
}

.btn_menu{
  width: 26px;
  height: 13px;
  &.btn_close{
    width:18px;
    height: 18px;
    margin-right: 6px;
  }
}

#menu
{
  position: fixed;
  width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
  display: block;
  background-color:rgba(0, 0, 0, 0.9);
  list-style-type: none;
  text-align: center;
  z-index: 10;
  ul{
    list-style-type: none;
    margin: 0 auto;
    margin-top: 30px;
    padding-inline-start: unset;
  }
  ul>li{
    padding: 30px 0;
    &:hover{
      opacity: 0.85;
    }
  }
  a{
    color:#fff;
    text-decoration: none;
  }
  .title{
    font-size: 63.5px;
  }
  .contact{
    font-size: 1rem;
    font-style: normal;
  }
  .social-media{
    padding-top: 1rem;
  }
}

@media (max-width: $mobile) { 
  nav {
    justify-content: flex-start;
    .logo{
      margin-left: 2rem;
    }
    #menuToggle{
      right: 2rem;
    }
  }
  #menu{
    ul>li {
      padding: 1.5rem 0;
    }
  }
}
</style>